/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import MedicalIcon from '../../public/icons/icon-medical.svg';
import DentalIcon from '../../public/icons/icon-dentist.svg';
import PhramacyIcon from '../../public/icons/icon-pharmacy.svg';
import VisionIcon from '../../public/icons/icon-vision.svg';

const Card = (props) => {
    const { cardname, selectedProvider } = props;
    const cardName = useRef(null);
    const handleCard = (i) => {
        i.preventDefault();
        // eslint-disable-next-line react/destructuring-assignment
        props.zipCallBack(cardname);
    };
    const cardStyle = selectedProvider && selectedProvider === cardname ? 'search-block__network-item is-selected' : 'search-block__network-item';

    const showIcon = (name) => {
        let icn;
        switch (name.trim()) {
            case 'Medical':
                icn = <MedicalIcon />;
                break;
            case 'Dental':
                icn = <DentalIcon />;
                break;
            case 'Pharmacy':
                icn = <PhramacyIcon />;
                break;
            case 'Vision':
                icn = <VisionIcon />;
                break;
            default:
                break;
        }
        return icn;
    };

    return (
        <div className={cardStyle}>
            <div className="search-block__network-item-head" value={cardname} onClick={handleCard} onKeyDown={handleCard}>
                <div id="networkList" className="search-block__network-item-label" value={cardname} ref={cardName}>
                    {showIcon(cardname)}
                    <span>{cardname}</span>
                </div>
            </div>
        </div>
    );
};

Card.propTypes = {
    cardname: PropTypes.string.isRequired,
    selectedProvider: PropTypes.string,
    zipCallBack: PropTypes.func.isRequired
};

Card.defaultProps = {
    selectedProvider: ''
};

export default Card;
